import React from 'react';

export default function Egg() {
	return (
		<g>
			<path fill="#FFFFFF" d="M136.57094,386.00687c-9.07789-3.84058-22.32984-6.50665-39.02149-6.50665
				c-54.58496,0-65.10107,12.24689-67.20752,18.30127c-2.61865,7.19336,12.34448,7.30969,14.10889,10.47095
				c1.76465,3.16119,4.42017,7.74213,9.19434,9.50336c21.09985,7.78363,53.11108-4.88306,64.43018-4.31781
				c26.27076,1.31195,32.0398-4.32208,33.5442-9.46393C154.20766,397.01859,146.17299,390.06931,136.57094,386.00687z" />
			<path fill="#FFFFFF" d="M68.60095,410.03833c18.31055,4.42285,39.78943-4.7666,50.40247-4.21484
				c15.24854,0.79272,26.32446-0.47607,32.88892-2.74756c0.59981-2.4982-0.1138-4.97687-1.72424-7.30417
				c-2.68408-3.87885-7.85938-7.33725-13.59729-9.76492c-9.07764-3.84058-22.32983-6.50659-39.02124-6.50659
				c-19.96701,0-34.03668,1.63882-43.95537,4.01379c-1.59065,0.38089-3.07455,0.7807-4.45889,1.19571
				c-1.06628,0.31964-4.23214,5.29114-2.88215,9.46393C48.54278,401.25085,56.0083,406.99658,68.60095,410.03833z" />
			<path fill="#FFBB10" d="M97.35204,397.98923c-12.46178,0-22.56405-4.32852-22.56405-9.55365
				c0-12.46176,10.10227-20.56244,22.56405-20.56244s22.56406,8.10068,22.56406,20.56244
				C119.9161,393.66071,109.81383,397.98923,97.35204,397.98923z" />
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Toy/Egg.js